<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: { type: Number, default: 0 }, // 0–1
  size: { type: Number, default: 52 },
  width: { type: Number, default: 5 },
  color: { type: String, default: 'var(--c-accent)' },
})

const radius = computed(() => (props.size - props.width) / 2)
const circumference = computed(() => 2 * Math.PI * radius.value)
const dash = computed(() => circumference.value * Math.min(1, Math.max(0, props.value)))
</script>

<template>
  <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" class="-rotate-90">
    <circle
      :cx="size / 2"
      :cy="size / 2"
      :r="radius"
      fill="none"
      stroke="var(--c-line)"
      :stroke-width="width"
    />
    <circle
      :cx="size / 2"
      :cy="size / 2"
      :r="radius"
      fill="none"
      :stroke="color"
      :stroke-width="width"
      stroke-linecap="round"
      :stroke-dasharray="`${dash} ${circumference}`"
      class="transition-[stroke-dasharray] duration-500"
    />
  </svg>
</template>
